module.exports = __webpack_public_path__ + "14ab4586e1f0a089476ff0a39dfd59d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/Absolute_Steuerbelastung_2017-desktop.svg
// module id = 765
// module chunks = 1